import { useCallback, useRef } from 'react'
import { actions } from '@/store'

export function useRightSidebarResize(snap, setIsResizing) {
  const isResizingRef = useRef(false)

  const handleRightSidebarResizeMouseDown = useCallback(
    (e) => {
      // Prevent default to stop scrolling/selection
      if (e.cancelable) e.preventDefault()
      e.stopPropagation()

      setIsResizing(true)
      isResizingRef.current = true

      // Get initial X coordinate
      let startX
      if ('touches' in e) {
        startX = e.touches[0].clientX
      } else {
        startX = e.clientX
      }

      const startWidth = snap.uiSettings.rightSidebarWidth

      function handleEnd() {
        setIsResizing(false)
        isResizingRef.current = false
        window.removeEventListener('mousemove', handleMouseMove)
        window.removeEventListener('mouseup', handleEnd)
        window.removeEventListener('touchmove', handleTouchMove)
        window.removeEventListener('touchend', handleEnd)
        document.body.style.cursor = ''
      }

      function handleMove(clientX) {
        // Dragging left increases width, dragging right decreases width
        const delta = startX - clientX
        const rawWidth = startWidth + delta
        const viewportWidth = window.innerWidth || 0
        const leftSidebarWidth = snap.uiSettings.showSidebar ? snap.uiSettings.sidebarWidth : 0
        const reservedMainWidth = 560
        const maxByViewport = Math.max(280, viewportWidth - leftSidebarWidth - reservedMainWidth)
        const maxWidth = Math.min(800, maxByViewport)

        // If dragged below 150px, close it (like left sidebar)
        if (rawWidth < 150) {
          actions.setUIVisibility('showRightPanel', false)
          actions.setRightSidebarWidth(400) // Reset for next time it's opened
          handleEnd()
          return
        }

        // Keep right panel readable but never let it squeeze out the main content.
        const newWidth = Math.min(Math.max(280, rawWidth), maxWidth)
        actions.setRightSidebarWidth(newWidth)
      }

      function handleMouseMove(ev) {
        handleMove(ev.clientX)
      }

      function handleTouchMove(ev) {
        handleMove(ev.touches[0].clientX)
      }

      document.body.style.cursor = 'col-resize'
      window.addEventListener('mousemove', handleMouseMove)
      window.addEventListener('mouseup', handleEnd)
      window.addEventListener('touchmove', handleTouchMove)
      window.addEventListener('touchend', handleEnd)
    },
    [
      snap.uiSettings.rightSidebarWidth,
      snap.uiSettings.showSidebar,
      snap.uiSettings.sidebarWidth,
      setIsResizing,
    ],
  )

  return {
    handleRightSidebarResizeMouseDown,
    isResizingRef,
  }
}
